"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScheduleUpdate = void 0;
var react_1 = require("react");
var use_isomorphic_layout_effect_1 = require("./use-isomorphic-layout-effect");
function useScheduleUpdate(deps) {
    if (deps === void 0) { deps = []; }
    var scheduleUpdateRef = react_1.useRef(null);
    use_isomorphic_layout_effect_1.useIsomorphicLayoutEffect(function () { return function () {
        if (scheduleUpdateRef.current) {
            scheduleUpdateRef.current();
        }
    }; }, deps);
    return scheduleUpdateRef;
}
exports.useScheduleUpdate = useScheduleUpdate;
//# sourceMappingURL=use-schedule-update.js.map